export default __webpack_public_path__ + "static/media/Arkade.299f957f.png";